import InfiniteTable, { ColumnsType } from '@/components/_common/InfiniteTable';
import {
  ListCreditsSupplierQuery,
  SupplierColumn,
  SupplierOrderColumn,
} from '@/core/domain/people/Suppliers/Suppliers.types';
import { ItemsPurchaseReturnAll } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import supplierReturnedItemsOrderColumns from '@/utils/functions/supplierReturnedItemsOrderColumns/workorderOrderColumns';
import { quantityFormatter } from '@/utils/number';
import formatterPrice from '@/utils/number/formatterPrice';
import { Dispatch, SetStateAction } from 'react';

interface Props {
  itemsReturn: ItemsPurchaseReturnAll[];
  isLoading: boolean;
  hasNextPage?: boolean;
  fetchNextPage: () => void;
  setQueryParams: Dispatch<SetStateAction<ListCreditsSupplierQuery>>;
}

const SupplierReturnedItemsList: React.FC<Props> = ({
  itemsReturn,
  isLoading,
  hasNextPage,
  fetchNextPage,
  setQueryParams,
}) => {
  const columns: ColumnsType<ItemsPurchaseReturnAll> = [
    {
      dataIndex: SupplierColumn.companyName,
      key: SupplierOrderColumn.COMPANY_NAME,
      title: 'Empresa',
      ellipsis: true,
      width: 200,
      sorter: true,
    },
    {
      dataIndex: SupplierColumn.purchaseCode,
      key: SupplierOrderColumn.PURCHASE_CODE,
      title: 'Compra',
      render: (value) => value || '-',
      ellipsis: true,
      width: 200,
      sorter: true,
    },
    {
      dataIndex: SupplierColumn.purchaseItemName,
      key: SupplierOrderColumn.PURCHASE_ITEM_NAME,
      title: 'Descrição',
      render: (value) => value || '-',
      ellipsis: true,
      width: 230,
      sorter: true,
    },
    {
      dataIndex: SupplierColumn.invoiceKey,
      key: SupplierOrderColumn.INVOICE_KEY,
      title: 'Chave NF-e',
      ellipsis: true,
      width: 230,
      sorter: true,
    },
    {
      dataIndex: SupplierColumn.quantity,
      key: SupplierOrderColumn.QUANTITY,
      title: 'Quantidade',
      render: (value) => quantityFormatter(value),
      ellipsis: true,
      width: 90,
      sorter: true,
    },
    {
      dataIndex: SupplierColumn.value,
      key: SupplierOrderColumn.VALUE,
      title: 'Valor',
      render: (value) => formatterPrice(value),
      ellipsis: true,
      width: 90,
      sorter: true,
    },
  ];

  return (
    <>
      <InfiniteTable
        columns={columns}
        dataSource={itemsReturn}
        loading={isLoading}
        rowKey={(row) => row.id}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        onChange={(_p, _f, sorter) => {
          if (!Array.isArray(sorter)) {
            supplierReturnedItemsOrderColumns(sorter, setQueryParams);
          }
        }}
      />
    </>
  );
};

export default SupplierReturnedItemsList;
